export default defineNuxtPlugin(nuxtApp => {
    // Doing something with nuxtApp
  })